(function () {
  function formatMoney(cents) {
    if (typeof theme !== 'undefined' && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return cents;
  }

  function update(el, cart) {
    var threshold = parseInt(el.dataset.threshold, 10);
    if (!threshold || !cart) return;

    var messageEl = el.querySelector('.sc-fsb-message');
    var fillEl = el.querySelector('.sc-fsb-fill');
    var total = cart.total_price;
    var percent = Math.min((total / threshold) * 100, 100);

    if (fillEl) fillEl.style.width = percent + '%';

    if (messageEl) {
      if (total >= threshold) {
        messageEl.textContent = el.dataset.messageAfter;
      } else {
        var remaining = threshold - total;
        messageEl.textContent = el.dataset.messageBefore.replace('[amount]', formatMoney(remaining));
      }
    }
  }

  function refresh(el) {
    if (typeof theme === 'undefined' || !theme.cart || !theme.cart.getCart) return;
    theme.cart.getCart().then(function (cart) {
      update(el, cart);
    });
  }

  function init(el) {
    if (el.dataset.scFsbInitialized === 'true') return;
    el.dataset.scFsbInitialized = 'true';

    refresh(el);

    document.addEventListener('cart:updated', function (evt) {
      var cart = evt.detail.cart;
      // The theme dispatches this event with the raw /cart/change.js response even
      // when the change failed (e.g. quantity above available inventory), in which
      // case it's an error object with no total_price. Re-fetch the real cart
      // instead of trusting that payload.
      if (cart && typeof cart.total_price === 'number') {
        update(el, cart);
      } else {
        refresh(el);
      }
    });

    document.addEventListener('ajaxProduct:added', function () {
      refresh(el);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.sc-fsb').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });
})();
